import { _, $, Backbone } from "../../../vendor";
import { Backform, Notification, Biscuit } from "../../utils";
import InboomaBaseView from "../InboomaBaseView";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

export default InboomaBaseView.extend({
  template: _.noop,

  ui: {
    errorMessageField: ".off-canvas__form-error",
  },

  initialize() {
    this.render();
  },

  onRender() {
    this.getUI("errorMessageField").addClass("hide");

    if (this.model.get("id") == "") {
      this.$el.find(".inb-page-title").html(this.t("add_${a}", { a: this.t("slot") }, "capital"));
    } else {
      this.$el.find(".inb-page-title").html(this.t("edit_${a}", { a: this.t("slot") }, "capital"));
    }

    const that = this,
      fields = [
        {
          name: "name",
          label: this.t("name", null, "capital"),
          control: "input",
          required: true,
          size: {
            large: "12",
          },
        },
        {
          name: "secret",
          label: this.t("resource_secret", null, "capital"),
          control: "input",
          size: {
            large: "12",
          },
        },
        {
          name: "mac",
          label: this.t("mac_adress"),
          required: true,
          control: "input",
          disabled: Biscuit.get("user.role") != "admin", // WAS: that.model.get('mac') !== ''
          size: {
            large: "12",
          },
        },
        {
          name: "location_id",
          label: this.t("resource_start_location", null, "capital"),
          control: "selector",
          required: true,
          disabled: this.model.get("id") != "",
          options: _.map(this.options.parent.get("locations"), (location) => {
            return { label: location.name, value: location.id };
          }),
        },
        {
          label: this.t("save"),
          control: "button",
          extraClasses: ["expanded button-submit"],
        },
      ],
      resourcesModal = new Foundation.Reveal(this.$el),
      isNew = this.model.get("id") == "",
      form = new Backform.Form({
        el: that.$el.find("form"),
        model: that.model,
        fields: fields,

        events: {
          "click .button-submit": function (ev) {
            ev.preventDefault();

            $(that.$el.find("form")).foundation("validateForm");

            if (
              typeof that.model != "undefined" &&
              that.model.isValid() &&
              !that.$el.find("form .is-invalid-input").length
            ) {
              const isNew = that.model.get("id") == "";

              that.model = OffCanvasBehavior.prototype.normalizeModel(that.model);
              that.model.set("client_id", Number(Biscuit.get("user.client_id")));

              // delete battery_value as clashing with API
              delete that.model.attributes.battery_value;

              if (isNew) {
                const _location = _.findWhere(that.options.parent.get("locations"), {
                  id: that.model.get("location_id"),
                });

                if (typeof _location == "undefined") {
                  alert("No valid location selected, will abort");
                  return;
                }

                that.model.set({
                  latitude: _location.latitude,
                  longitude: _location.longitude,
                });
              }

              that.model.save(null, {
                patch: true,
                success: function (model, response, options) {
                  resourcesModal.close();

                  new Notification({
                    message: that.t(
                      isNew ? "added_${a}" : "updated_${a}",
                      { a: that.t("resource") },
                      "capital",
                    ),
                    duration: 5000,
                    closeable: true,
                    icon: "fi fi-check",
                  });

                  if (isNew) {
                    let newResources = that.options.parent.get("resources");
                    newResources.push(model);

                    that.options.parent.set("resources", newResources);
                  }

                  console.log("saved res for contingent #" + that.options.parent.get("id"));
                  that.options.parent.trigger("changed");
                },
                error: function (model, xhr, options) {
                  console.log("error saving", model, xhr, options);

                  //resourcesModal.close();

                  that
                    .getUI("errorMessageField")
                    .removeClass("hide")
                    .html(that.t("request_error"))
                    .fadeIn("fast");
                },
              });
            } else {
              if (typeof that.model != "undefined") {
                that
                  .getUI("errorMessageField")
                  .removeClass("hide")
                  .html(that.t("form_validation_error"))
                  .fadeIn("fast");
              }
            }
          },
        },
      }).render();

    new Foundation.Abide(this.$el.find("form"), { liveValidate: true });
    resourcesModal.open();

    $(document).on("closed.zf.reveal", () => {
      that.unbind();
      delete that.model;
      Backbone.history.navigate("contingents");
      $(document).off("closed.zf.reveal");
    });
  },
});
